import { render, staticRenderFns } from "./AdjuntosDescarga.vue?vue&type=template&id=4d056594"
import script from "./AdjuntosDescarga.vue?vue&type=script&lang=js"
export * from "./AdjuntosDescarga.vue?vue&type=script&lang=js"
import style0 from "./AdjuntosDescarga.vue?vue&type=style&index=0&id=4d056594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports